import { render, staticRenderFns } from "./UpsertClientAddress.vue?vue&type=template&id=365ed564&"
import script from "./UpsertClientAddress.vue?vue&type=script&lang=js&"
export * from "./UpsertClientAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports